import React, { useEffect, useCallback, useState, useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import {
    action_fetch_transaction,
    action_fetch_transaction_messages, 
    action_fetch_customer_is_new
} from '../../../../../store/actions/pages/cart'

import {
    action_fetch_customer
} from '../../../../../store/actions/pages/customer'

import { update_order_address, fetchOrderConfirmIsNew, fetchReviewAlert, clientcall } from '../../../../../api'


import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector, useDispatch, useStore } from 'react-redux'
import LoadingPage from './fragments/loading-page'
import Loading from '../../../../components/loading/op-loading'
import OrderSummary from '../checkout/fragments/order-summary'
import AddressEditor from '../../fragments/address/address-editor'
import Cache from '../../../../../utils/cache'
import { TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from '../../../../../store/actions/ui'
import { useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { fetchUnifiedProcessing } from '../../../me/utils'
import MessengerCheckBtn from './fragments/messenger-checkbtn'
import ConfirmBanner from './fragments/confirm-banner';
import ConfirmRecommend from './fragments/confirm-recommend';
import ChangeCustomerMessage from './fragments/customer-message';
import { Lines } from '../unpaid/components/line';
import Address from './fragments/address';
import PayMethod from './fragments/pay-method';
import NormlaBox from './components/normla-box';
import OrderItems from './fragments/order-items';
import BlackCouponAlert from '../../../../layout/fragments/black-coupon-alert'
import GeekoEvents from '../../../../ads/events'
import { fbPurchase } from '../../../../../api/facebook-ctm-ads'
import RateMask from './fragments/rate-mask'
import Cookies from 'js-cookie'
import SendToSubscribe from '../../../components/subscribe/index'
import { TOGGLE_UI_LOTTERY } from '../../../../../store/actions/ui'


const Thanks = props => {
    useStyles(classes)

    const {
        transaction,
        transactionLoading, 
        transactionRefresh,
        transactionMessages, 
        transactionEmpty, 
        isNew
    } = useSelector(state => state.pageCart)

    const dispatch = useDispatch()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const global = useSelector(state => state.global);
    const { customer } = useSelector(state=>state.pageCustomer);
    const { config } = global


    const [addressEditor, setAddressEditor] = useState({})
 
    const [lotteryShow, setLotteryShow] = useState(false);
    const [couponAltShow, setCouponAltShow] = useState(true);
    const [showRateMask, setShowRateMask] = useState(false);
    const [showRateIframe, setShowRateIframe] = useState(false);
    const [showRateIframeUrl, setShowRateIframeUrl] = useState('');
    
    useEffect(() => {
        // Cache.remove('temp-order')
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (!transaction) {
                Thanks.fetchData(store, params, query, null)
            }
        }

        window.scrollTo({
            top: 0,
        })

        

        try {
            const latestTransactionId = Cache.get('latest-transaction')
            if(transaction){
                //去重   facebook不用去重
                GeekoEvents.purchase(transaction, latestTransactionId === transaction.transactionId)
                const contentIds = transaction.orderItems.map(i => i.productId)
                const quantity = transaction.orderItems.reduce((result, item)=> {return result + item.quantity}, 0)
                fbPurchase(contentIds, transaction.orderTotal.amount, transaction.orderTotal.currency, quantity)
                Cache.set("latest-transaction",transaction.transactionId, 30*24*60*60);
            }
        } catch (error) {
            console.error(error)
        }

        try{
            if(config && !global?.isiPhone && config?.shortName?.toLocaleLowerCase() == 'chicme'){
				let userName = customer?.name?.firstName ? customer?.name?.lastName ? customer.name.firstName + ' ' + customer.name.lastName : customer.name.firstName: ''
				let shippingName = transaction?.shippingDetail ? transaction.shippingDetail.name : ''
                let userEmail = customer?.email || transaction?.shippingDetail?.email || ''
				fetchReviewAlert({email: userEmail, name: userName || shippingName, transactionId: transaction?.transactionId}).then(res => {
					if(res?.code == 200 && res.result){
                        const {domain, a, b, c, e} = res.result
                        setShowRateMask(true)
                        setShowRateIframeUrl(`https://www.trustpilot.com/evaluate-unique-link/embed/${domain}?a=${a}&b=${b}&c=${encodeURIComponent(c)}&e=${e}`)
					}
                    //  else {
                    //     // 测试用
                    //     let obj = {a:"abc-123", b:"c2hhb2xlaUAxNjMuY29t", c:"shao", e:"9861b42ab43afef7a64bb283043eab30d65cb4c8", domain:"chicme.com"}
                    //     const {domain, a, b, c, e} = obj
                    //     setShowRateMask(true)
                    //     setShowRateIframeUrl(`https://www.trustpilot.com/evaluate-unique-link/embed/${domain}?a=${a}&b=${b}&c=${encodeURIComponent(c)}&e=${e}`)
                    // }
				})
			}
            
        } catch (error) {
            console.error(error)
        }
        
        if(transactionEmpty){
            window.location.replace('/');
        }

        clientcall(params?.transactionId)


        Cookies.set('c_has_order', 1, { path: '/', expires: 365 })
    }, []);

    useEffect(() => {

    }, [])

    const backHandle = () => {
        window.location.href = '/'
    }

    const editAddressHandle = e => {
        setAddressEditor({
            show: true,
            address: transaction.shippingDetail
        })
    }

    const onSubmitAddress = async values => {
        const response = await update_order_address({
            ...values,
            transactionId: transaction.transactionId
        })
        if (response?.code === 200) {
            // dispatch(action_refresh_unpaid_checkout(unpaid.orderId))

            await dispatch(action_fetch_transaction(transaction.transactionId, true));

            setAddressEditor({
                address: null,
                show: false
            })

            if (values?.email) {
                Cache.set('customerEmail', values?.email, 365 * 24 * 60 * 60)
            }
        } else{
            handleError({ message: response?.result || 'Network error' })
        }
        return response
    }



    const handleError = state => {
        if (state.type === 'no_paymethod') {
            //no paymethod
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: <FormattedMessage id="select_pay_method" defaultMessage="Please select a pay method!" />,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        } else if (state.message) {
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: state.message,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        }
    }

    // const isNew = useMemo(() =>{
    //     return global.isFirstOrder
    // }, [global.isFirstOrder]);

    const isLogin = useMemo(() =>{
        return !!customer?.id
    }, [customer]);

    const handleLotteryShow = useCallback(() =>{
        dispatch({
            type: TOGGLE_UI_LOTTERY,
            payload: true
        })
    }, []);

    return <div className={classes.TransitionContainer}>
        {
            transactionLoading && <LoadingPage />
        }

        {
            transactionRefresh && <Loading />
        }

        {
            !transactionLoading && transaction && <React.Fragment>
                <ChangeCustomerMessage 
                    transaction={transaction} 
                    customer={customer} 
                    isNew={isNew} 
                    transactionMessages={transactionMessages} 
                    isLogin={isLogin} 
                />

                <NormlaBox>
                    <Lines>
                        <Address address={transaction.shippingDetail} onEdit={editAddressHandle} />
                    </Lines>
                </NormlaBox>
                
                <NormlaBox>
                    <PayMethod 
                        payMethodInfo={transaction.payMethodInfo} 
                        accountNo={transaction.accountNo} 
                        shippingDetail={transaction.shippingDetail} 
                    />
                </NormlaBox>

                <NormlaBox>
                    <OrderItems 
                       checkoutItems={transaction.orderItems} 
                       orderId={transaction.id} 
                       orderTotal={transaction.orderTotal} 
                       shippingPrice={transaction.shippingPrice} 
                    />
                </NormlaBox>

                {
                    customer?.id && <React.Fragment>
                        <SendToSubscribe 
                            country={transaction.shippingDetail?.country?.value} 
                            customer={customer} 
                            className={classes.SendToSubscribe} 
                            phoneNumber={transaction.shippingDetail?.phoneNumber} 
                        />
                    </React.Fragment>
                }
                
                <MessengerCheckBtn customer={customer} transaction={transaction} />

                <ConfirmBanner />

                <ConfirmRecommend transaction={transaction} />

                <AddressEditor disableCountry address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />
            
                {
                    couponAltShow && transaction.hasLuckyDrawWebView && <React.Fragment>
                        <BlackCouponAlert 
                            orderId={transaction.id} 
                            isConfirm 
                            onConfirmClose={() =>{
                                handleLotteryShow();
                                // setLotteryShow(true);
                                setCouponAltShow(false);
                            }} 
                        />
                    </React.Fragment>
                }

                <RateMask
                    showRateMask={showRateMask}
                    showRateIframe={showRateIframe}
                    setShowRateMask={setShowRateMask}
                    showRateIframeUrl={showRateIframeUrl}
                    webSite={config?.shortName}
                    setShowRateIframe={setShowRateIframe}
                    />

                {/* {
                    lotteryShow && <EasterLottery onClose={() =>{
                        setLotteryShow(false)
                    }} />
                } */}
            </React.Fragment>
        }
    </div>
}

Thanks.fetchData = async (store, params, search, headers) => {
    const { transactionId } = params
    let transaction = await store.dispatch(action_fetch_transaction(transactionId, false, headers));
    // 
    const values = await Promise.all([
        store.dispatch(action_fetch_transaction_messages(headers)),
        store.dispatch(action_fetch_customer(headers)),
        store.dispatch(action_fetch_customer_is_new(transaction?.buyerId, headers)),
	])
	return [transaction, ...values]
}

export default Thanks